import { render, staticRenderFns } from "./salesCounter.vue?vue&type=template&id=8680d7f8&scoped=true&"
import script from "./salesCounter.vue?vue&type=script&lang=js&"
export * from "./salesCounter.vue?vue&type=script&lang=js&"
import style0 from "./salesCounter.vue?vue&type=style&index=0&id=8680d7f8&prod&scoped=true&lang=css&"
import style1 from "./salesCounter.vue?vue&type=style&index=1&id=8680d7f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8680d7f8",
  null
  
)

export default component.exports